// src/pages/PrivacyPage.js
import React from 'react';

function PrivacyPage() {
  return (
    <div className="pricing-page" style={{textAlign:'left'}}>
      <h2>Privacy Policy</h2>
      <p>We respect your privacy and are committed to protecting it. This page outlines what data we process to deliver Compliance Guardian and how we safeguard it.</p>
      <ul>
        <li>We use Azure AD for authentication; we do not store your password.</li>
        <li>We collect configuration and compliance findings necessary to provide the service.</li>
        <li>You can request data export or deletion via <a href="mailto:support@complianceguardian.cloud">support@complianceguardian.cloud</a>.</li>
      </ul>
      <p>For full details or questions, contact us at <a href="mailto:support@complianceguardian.cloud">support@complianceguardian.cloud</a>.</p>
    </div>
  );
}

export default PrivacyPage;
